/**
 *
 * Asynchronously loads the component for EditableLists
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
